module.exports = __webpack_public_path__ + "h5/img/banner_4.e36f9f2b.jpg";